<header class="b-top border-xl core-water-leaf-border">
  <a [routerLink]="logoRoute"><img width="200px" [src]="logoPath" /></a>
  <div class="profile">
    <span *ngIf="isInternalUser" class="internal-context-label">
      {{ internalHeaderLabel }}
    </span>

    <f-profile-menu
      uuid="header-profile-menu"
      [headerText]="userEmail"
      logOutButtonText="Log off"
      srLabel="User profile menu"
      srDialogLabel="User profile"
      srCloseButtonLabel="Close profile menu"
      myProfileLabelText="My profile"
      [myProfileItems]="profileMenuItems"
      (logoutButtonClicked)="onLogoutClicked()"
      (logOutButtonClicked)="onLogoutClicked()"
      (profileMenuItemClicked)="onProfileMenuItemClicked($event)">
    </f-profile-menu>

    <span style="color: rgb(20, 134, 249);" class="language-selection">
      <fa-icon [icon]="faGlobe"></fa-icon>
      EN
    </span>
  </div>
</header>